import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { SharingPanelService } from '../../shared-service/sharing-panel-service';
import { BaseService } from '../../shared-service/base.service';

declare var $: any;

@Component({
	selector: 'app-sharing-panel',
	templateUrl: './sharing-panel.component.html',
	styleUrls: ['./sharing-panel.component.css'],
	encapsulation: ViewEncapsulation.None
})

export class SharingPanelComponent implements OnInit, OnDestroy {

	@Input() data: object|any;
	options: object = {
		keyboard: true,
		backdrop: true,
		show: true
	}
	isActiveMessageBox: boolean = false;
	isActiveFileUpload: boolean = false;
	constructorName: string = '';
	sText: string = '';

	colorArray: any[] = ['red', 'blue', 'black', 'yellow', 'green'];
	//fontArray: any[] = ['serif', 'monospace'];
	//alignArray: any[] = ['right','left','center','justify'];

	editorConfig = {
		toolbar: [
			['bold', 'italic', 'underline', 'strike'],        // toggled buttons
			//['blockquote', 'code-block'],

			//[{ 'header': 1 }, { 'header': 2 }],               // custom button values
			[{ 'list': 'ordered' }, { 'list': 'bullet' }],
			//[{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
			//[{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
			[{ 'direction': 'rtl' }],                         // text direction

			[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
			[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

			[{ 'color': this.colorArray.slice() }, { 'background': this.colorArray.slice() }],          // dropdown with defaults from theme
			//[{ 'font': this.fontArray.slice() }],
			//[{ 'align': this.alignArray.slice() }],        // left is not working

			//['link', 'image', 'video'],                         // link and image, video

			//['clean']                                         // remove formatting button
		]
	};


	constructor(private sps: SharingPanelService, public bs: BaseService) {
		this.constructorName = 'SharingPanelComponent';
	}

	ngOnInit() {
		console.log("ngOnInit SharingPanelComponent");

		this.sText = '';
		this.openModelPopup();

		if (this.data.hasOwnProperty('TileId')) {
			this.isActiveMessageBox = false;
		}
		else {
			this.isActiveMessageBox = true;
		}
		if (this.data.hasOwnProperty('ShareFileType')) {
			this.isActiveFileUpload = true;
		}
		else {
			this.isActiveFileUpload = false;
		}
		console.log(this.data['setting']);

	}

	ngOnDestroy() {
		console.log("ngOnDestroy SharingPanelComponent");
	}

	openModelPopup() {		
		$('#sharingModal').modal(this.options);
	}

	closePanel() {
		$('#sharingModal').modal('hide');
		this.sps.resetPanel();
		this.sps.sharedSuccess.next(true);
		this.sps.updateActiveWall(false);
	}

	ShareData() {
		//this.sText = $('#ShareText').val();
		let userIds = '';
		let selectedItems = '';
		let postParam : any = {};
		postParam['UserSelectionType'] = 'O';
		if ($('input[name=Users]:checked').val() == 'all') {
			console.log('Get tree data');
			selectedItems = this.sps.refreshList();
			postParam['UserSelectionType'] = 'O';
		} else {
			userIds = $('.chips-list').map(function () {
				return this.id;
			}).get().join(',');
			postParam['UserSelectionType'] = 'U';
		}

		postParam['SelectedUsers'] = userIds;
		postParam['SelectedFieldDetails'] = selectedItems;

		if (postParam['UserSelectionType'] == 'U' && postParam['SelectedUsers'] == '') {
			alert(this.bs.getResource('rbkey_VldtShrUsrMSG'));
			return false;
		}
		else {
			if (this.data.hasOwnProperty('ShareFileType')) {
				if (this.sText == null || this.sText == undefined || this.sText == 'undefined' || this.sText == '') {
					$('#rtfBox').focus();
					$('#rtfBox').addClass('errorBox');
					alert(this.bs.getResource('rbkey_ShrTxtGrpMndtryMSG'));
					return false;
				}
				else {
					postParam['TileType'] = 0;
					postParam['TileId'] = 0;
					postParam['ShareId'] = 0;
					postParam['TileItemId'] = 0;
					postParam['ShareComment'] = this.sText;
					postParam['ShareCommentDescription'] = '';
					postParam['InlineFilePath'] = $('#encryptedFilePath').val();
					postParam['AttachmentFilePath'] = $('#encryptedAttachementPath').val();
					postParam['UploadedFileName'] = '';
					postParam['UploadedFilePath'] = '';
				}
			}
			else if (this.data.hasOwnProperty('TileId')) {
				postParam['TileType'] = 1;
				postParam['TileId'] = this.data['TileId'];
				postParam['ShareId'] = 0;
				postParam['TileItemId'] = 0;
				postParam['ShareComment'] = '';
				postParam['ShareCommentDescription'] = '';
				postParam['InlineFilePath'] = '';
				postParam['AttachmentFilePath'] = '';
				postParam['UploadedFileName'] = '';
				postParam['UploadedFilePath'] = '';
			}
			else if (this.data.hasOwnProperty('CourseLaunchId')) {
				if (this.sText == null || this.sText == undefined || this.sText == 'undefined' || this.sText == '') {
					$('#rtfBox').focus();
					$('#rtfBox').addClass('errorBox');
					alert(this.bs.getResource('rbkey_ShrTxtGrpMndtryMSG'));
					return false;
				}
				else {
					postParam['TileType'] = 2;
					postParam['TileId'] = 0;
					postParam['ShareId'] = 0;
					postParam['TileItemId'] = this.data['CourseLaunchId'];
					postParam['ShareComment'] = this.sText;
					postParam['ShareCommentDescription'] = this.data['CourseDescription'];
					postParam['InlineFilePath'] = $('#encryptedFilePath').val();
					postParam['AttachmentFilePath'] = $('#encryptedAttachementPath').val();
					postParam['UploadedFileName'] = this.data['UploadedFileName'];
					postParam['UploadedFilePath'] = this.data['UploadedFilePath'];
				}
			}

			else if (!this.data.hasOwnProperty('CourseLaunchId') && this.data.hasOwnProperty('conversationId')) {
				if (this.sText == null || this.sText == undefined || this.sText == 'undefined' || this.sText == '') {
					$('#rtfBox').focus();
					$('#rtfBox').addClass('errorBox');
					alert(this.bs.getResource('rbkey_ShrTxtGrpMndtryMSG'));
					return false;
				}
				else {
					postParam['TileType'] = 3;
					postParam['TileId'] = 0;
					postParam['ShareId'] = 0;
					postParam['TileItemId'] = this.data['conversationId'];
					postParam['ShareComment'] = this.sText;
					postParam['ShareCommentDescription'] = this.data['ConversationDesc'];
					postParam['InlineFilePath'] = $('#encryptedFilePath').val();
					postParam['AttachmentFilePath'] = $('#encryptedAttachementPath').val();
					postParam['UploadedFileName'] = this.data['UploadedFileName'];
					postParam['UploadedFilePath'] = this.data['UploadedFilePath'];
				}
			}
			else if (this.data.hasOwnProperty('SurveyId')) {
				if (this.sText == null || this.sText == undefined || this.sText == 'undefined' || this.sText == '') {
					$('#rtfBox').focus();
					$('#rtfBox').addClass('errorBox');
					alert(this.bs.getResource('rbkey_ShrTxtGrpMndtryMSG'));
					return false;
				}
				else {
					postParam['TileType'] = 4;
					postParam['TileId'] = 0;
					postParam['ShareId'] = 0;
					postParam['TileItemId'] = this.data['conversationId'];
					postParam['ShareComment'] = this.sText;
					postParam['ShareCommentDescription'] = '';
					postParam['InlineFilePath'] = $('#encryptedFilePath').val();
					postParam['AttachmentFilePath'] = $('#encryptedAttachementPath').val();
					postParam['UploadedFileName'] = '';
					postParam['UploadedFilePath'] = '';
				}
			}
			else if (this.data.hasOwnProperty('BlogId')) {
				if (this.sText == null || this.sText == undefined || this.sText == 'undefined' || this.sText == '') {
					$('#rtfBox').focus();
					$('#rtfBox').addClass('errorBox');
					alert(this.bs.getResource('rbkey_ShrTxtGrpMndtryMSG'));
					return false;
				}
				else {
					postParam['TileType'] = 5;
					postParam['TileId'] = 0;
					postParam['ShareId'] = 0;
					postParam['TileItemId'] = this.data['conversationId'];
					postParam['ShareComment'] = this.sText;
					postParam['ShareCommentDescription'] = this.data['BlogDesc'];
					postParam['InlineFilePath'] = $('#encryptedFilePath').val();
					postParam['AttachmentFilePath'] = $('#encryptedAttachementPath').val();
					postParam['UploadedFileName'] = '';
					postParam['UploadedFilePath'] = '';
				}
			}

			this.sps.ShareTimeLineTiles(postParam, "****").then((data) => {
				this.sps.sharedSuccess.next(true);
				$('#sharingModal').modal('hide');
				alert(this.bs.getResource('rbkey_ShrdScssfllyMSG'));
				this.sps.resetPanel();
				this.sps.updateActiveWall(false);
			}, (err) => {
				console.log(err);
			});

			// }
		}
	}
	validateText(val: string, actualVal: string) {
		if (this.data.hasOwnProperty('ShareFileType') || this.data.hasOwnProperty('CourseLaunchId') || (!this.data.hasOwnProperty('CourseLaunchId') && this.data.hasOwnProperty('conversationId')) || this.data.hasOwnProperty('SurveyId') || this.data.hasOwnProperty('BlogId')) {
			if (val.length == 1) {
				$('#rtfBox').addClass('errorBox');

			} else {
				$('#rtfBox').removeClass('errorBox');
				this.sText = actualVal;
				console.log(this.sText);
			}
		}
	}

	editorContentChanged(ev: Event|any) {
		console.log("editorContentChanged", ev);
		this.validateText(ev['editor']['root']['innerText'], ev['editor']['root']['innerHTML']);
	}


	backToHideUserList() {
		console.log('backToHideUserList');
		this.sps.updateComponentObj(this.data['setting'], { setting: true });
		this.sps.updateActiveWall(true);
	}

	saveHideUserList() {
		let userIds = '';
		let selectedItems = '';
		let postParam:any = {};
		postParam['UserSelectionType'] = 'O';
		if ($('input[name=Users]:checked').val() == 'all') {
			console.log('Get tree data');
			selectedItems = this.sps.refreshList();
			postParam['UserSelectionType'] = 'O';
		} else {
			userIds = $('.chips-list').map(function () {
				return this.id;
			}).get().join(',');
			postParam['UserSelectionType'] = 'U';
		}

		postParam['SelectedUsers'] = userIds;
		postParam['SelectedFieldDetails'] = selectedItems;

		if (postParam['UserSelectionType'] == 'U' && postParam['SelectedUsers'] == '') {
			alert(this.bs.getResource('rbkey_VldtHdUsrMSG'));
			return false;
		}
		else {
			this.sps.setBlockShareTimeLineTilesUser(postParam, "****").then((data) => {
				this.sps.updateComponentObj(this.data['setting'], { setting: true });
				this.sps.updateActiveWall(true);
				// this.closePanel();
			}, (err) => {
				console.log(err);
			});

		}

	}
}
